import { PurchaseStat } from '../../utils/types';
import { tokenAxios } from '../index';

export const requestPurchaseStat = async (businessName: string) => {
  const result = await tokenAxios.get<PurchaseStat>(`/purchaseStat?businessName=${businessName}`);
  return result.data;
};
